import { CandidateCount } from "../../../../../models/candidateCount";
import { Resume } from '../../../../../models/resume';
import { JobMatchAction } from '../../../../../models/jobMatchAction';
class UploadSingleResumeController {
    /*@ngInject*/
    constructor($scope, $rootScope, $timeout, $uibModal, $filter, modalService, jobMatchActionsService, alertsAndNotificationsService, resumeService, jobMatchService, candidateService, jobService, MESSAGECONSTANTS, utilityService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.modalService = modalService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.resumeService = resumeService;
        this.jobMatchService = jobMatchService;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.utilityService = utilityService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    $onInit() {
        this.initVariables();
        // if(this.controlObject) {
        //     this.controlObject = {
        //         cancel: this.cancelUploadResumes
        //     };
        // }
        this.$scope.$on('cancelUploadResume', (event, arg) => {
            this.cancelUploadResumes();
        });
        if (this.candidateId !== "") {
            this.isSingleCandidateUpload = true;
        }
        //initialize the variables
        if (!_.isNull(this.jobId) && this.jobId != '') {
            this.jobContextExistsFlag = true;
            this.createJobMatchesObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                manuallyMatchedFromUI: true,
                transactionId: null,
                isAssociateCandidate: false,
                overrideNoteDetails: []
            };
        }
        this.resumeList = [];
        // get the source types
        this.getAllSourceTypes(() => {
            if (!_.isNull(this.jobId) && this.jobId != '') {
                this.getLastAddedCandidateSourceTypeId();
            }
        });
        // wait for changes to take effect and then create wizard
        this.$timeout(() => {
            //create the wizard
            this.uploadResumesWizard = this.createUploadResumeWizard();
            //initialize the drop zone configuration
            const dropzoneElement = document.querySelector("form#resumeUploadDropzone");
            if (dropzoneElement) {
                this.resumeUploadDropzone = this.createResumeUploadDropzone();
            }
        }, 300);
        this.getAllActivityTypes();
    }
    initVariables() {
        this.defaultJobSourceTypeId;
        this.sourceTypeList = [];
        this.resumeList = [];
        this.sourceType = null;
        this.sourceTypeId = null;
        this.otherSourceTypeNotes = null;
        this.referrerName = null;
        this.referrerEmail = null;
        this.uploadResumesResponse = null;
        this.totalUploads = null;
        this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.candidateCount = null;
        this.createJobMatchesObject = null;
        // flags
        this.showCandidateUpdateFailureMessage = false;
        this.isSingleCandidateUpload = false;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.disablePreviousButtonFlag = false;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.fileUploadInProgressFlag = false;
        this.mandatoryFieldsError = false;
        this.disableSourceTypesFlag = false;
        this.resumeScoringDoneFlag = false;
        this.scoringCandidatesFlag = false;
        this.gettingCountsFlag = false;
        this.jobContextExistsFlag = false;
        this.associatingCandidatesFlag = false;
        this.selectedAllCandidatesFlag = false;
        this.displaySelectDeselectButtonFlag = true;
        this.additionalMatchRuleVerifiedCopy = false;
        this.additionalMatchRuleVerificationPassedCopy = false;
        this.isDirectCandidateUpdate = true;
    }
    getAllActivityTypes() {
        this.activityMap = [];
        this.jobService.getActivityTypes((data) => {
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getLastAddedCandidateSourceTypeId() {
        this.jobService.getLastAddedCandidateSourceTypeId(this.jobId, (data) => {
            this.defaultJobSourceTypeId = data.lastAddedCandidateSourceTypeId;
            this._setDefaultSourceType();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    /**
     * creates the resume upload drop zone.
     */
    createResumeUploadDropzone() {
        let dropZoneSettings = this._getDropZoneSettings();
        let resumeUploadDropzone = new Dropzone("form#resumeUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        resumeUploadDropzone.on('addedfile', (file, response) => {
            this.fileExistsFlag = true;
            this.updateActionButtons();
            $('.dz-progress').css({ top: '70%' });
        });
        resumeUploadDropzone.on('removedfile', (file, response) => {
            // if resume id exists, the file was already uploaded.
            if (!_.isUndefined(file.resumeId)) {
                this.candidateService.deleteCandidateOnResumeRemove(file.resumeId, (data) => {
                    // candidate deleted if created newly or reverted if it was existing candidate
                    // remove from resume list
                    _.remove(this.resumeList, {
                        resumeId: file.resumeId
                    });
                    // remove the resume from this.uploadResumesResponse files part. This parsing object (this.uploadResumesResponse) is used later for scoring
                    _.remove(this.uploadResumesResponse.files, {
                        resumeId: file.resumeId
                    });
                    this.uploadResumesResponse.successCount = this.uploadResumesResponse.successCount - 1;
                    this.totalUploads = this.totalUploads - 1;
                    if (this.resumeUploadDropzone.files.length === 0) {
                        this.fileExistsFlag = false;
                        // enable adding of further files if it was disabled
                        $(".dz-hidden-input").prop("disabled", false);
                    }
                    this.updateActionButtons();
                }, (error) => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            else {
                if (this.resumeUploadDropzone.files.length === 0) {
                    this.fileExistsFlag = false;
                    // enable adding of further files if it was disabled
                    $(".dz-hidden-input").prop("disabled", false);
                }
                this.updateActionButtons();
            }
        });
        resumeUploadDropzone.on('sendingmultiple', (file, xhr, formData) => {
            // disable the upload button to avoid multiple clicks
            this.disableUploadButtonFlag = true;
            // disable changing of source information
            this.disableSourceTypesFlag = true;
            // indicate that file upload is in progress
            this.fileUploadInProgressFlag = true;
            let resumeUpload = {};
            resumeUpload.companyId = this.$rootScope.userDetails.company.companyId;
            resumeUpload.userId = this.$rootScope.userDetails.id;
            resumeUpload.resumeSourceTypeId = this.sourceTypeId;
            resumeUpload.buIdList = [];
            // formData.append('resumeUpload', JSON.stringify(resumeUpload));
            formData.append("companyId", resumeUpload.companyId);
            formData.append("resumeSourceTypeId", resumeUpload.resumeSourceTypeId);
            formData.append("userId", resumeUpload.userId);
            formData.append("buIdList", resumeUpload.buIdList);
            if (this.sourceType.sourceType == 'Other') {
                formData.append("otherSourceTypeNotes", this.otherSourceTypeNotes);
            }
            else {
                formData.append("otherSourceTypeNotes", null);
            }
            if (this.sourceType.sourceType == 'Referral') {
                formData.append("referrerName", this.referrerName);
                formData.append("referrerEmail", this.referrerEmail);
            }
            else {
                formData.append("referrerName", null);
                formData.append("referrerEmail", null);
            }
            if (!_.isNull(this.jobId)) {
                formData.append("jobId", this.jobId);
            }
            if (this.candidateId && this.candidateId != '') {
                formData.append("candidateId", this.candidateId);
            }
        });
        resumeUploadDropzone.on('successmultiple', (fileArray, response) => {
            // remove file upload in progress flag
            this.fileUploadInProgressFlag = false;
            // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.RESUME_UPLOAD_SUCCESS, 'success');
            this.uploadResumesResponse = response;
            if (this.jobContextExistsFlag) {
                this.createJobMatchesObject.transactionId = this.uploadResumesResponse.transactionID;
            }
            this.totalUploads = response.successCount + response.failureCount;
            // go over the list, merge each item into a resume object and add to resume list
            if (angular.isDefined(response.files) && response.files.length > 0) {
                angular.forEach(response.files, (val, key) => {
                    fileArray[key].resumeId = val.resumeId;
                    if (val.isSuccess) {
                        this.resumeList.push(angular.merge(new Resume(), val));
                    }
                });
            }
            if (this.uploadResumesResponse.conflicts) {
                if (this.uploadResumesResponse.conflicts.disallowUpload) {
                    this.alertsAndNotificationsService.showAlertWithCallBack('Upload Failed', this.uploadResumesResponse.conflicts.uploadBlockedMessage, 'danger', () => {
                        if (this.cancelCallback) {
                            this.cancelCallback();
                        }
                    });
                }
                else if (!this.uploadResumesResponse.conflicts.disallowUpload && this.uploadResumesResponse.conflicts.conflictExists) {
                    this._showConflictsModal(this.uploadResumesResponse.conflicts);
                }
            }
            else {
                let message = response.message ? response.message : this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.RESUME_UPLOAD_SUCCESS;
                this.alertsAndNotificationsService.showBannerMessage(message, 'success');
                if (this.cancelCallback) {
                    this.cancelCallback();
                }
            }
            this.updateActionButtons();
            // disable adding of further files
            $(".dz-hidden-input").prop("disabled", true);
        });
        resumeUploadDropzone.on("error", (file, error) => {
            let elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, (element, index) => {
                let filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                let errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
            this.disableNextButtonFlag = false;
        });
        return resumeUploadDropzone;
    }
    _getDropZoneSettings() {
        let dropZoneSettings = {};
        let maxFilesToUpload = 100;
        if (this.isSingleCandidateUpload) {
            maxFilesToUpload = 1;
        }
        dropZoneSettings = {
            url: this.resumeService.getUploadUrl(),
            paramName: () => {
                return "file";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        // else {
        //     dropZoneSettings = {
        //         url: this.resumeService.getUploadUrl(),
        //         paramName: () =>  {
        //             return "file";
        //         },
        //         acceptedFiles: ".pdf,.xlsx,.docx,.doc",
        //         maxFiles: 1,
        //         maxFilesize: 10,
        //         maxThumbnailFilesize: 10,
        //         timeout: 300000,
        //         addRemoveLinks: true,
        //         autoProcessQueue: false
        //     }
        // }
        return dropZoneSettings;
    }
    /**
     * create the wizard for the upload resume workflow
     */
    createUploadResumeWizard() {
        let uploadResumesWizard = $("#uploadResumesWizard").wizard();
        $('#uploadResumesWizard').on('actionclicked.fu.wizard', (evt, data) => {
            if (data.direction == "next") {
                switch (data.step) {
                    case 1:
                        // remove the remove button from the file.
                        $('.dz-remove').remove();
                        if (!this.resumeScoringDoneFlag) {
                            // disable previous and next (complete) button when processing
                            this.disableNextButtonFlag = true;
                            this.disablePreviousButtonFlag = true;
                            // initialize the loading flag
                            this.scoringCandidatesFlag = true;
                            if (!this.isSingleCandidateUpload) {
                                this._runScoringForResumes();
                            }
                            else {
                                this.runResumeScoringForAssociate(null, null);
                            }
                        }
                        else {
                            //if(!this.jobContextExistsFlag){
                            this._getCandidateCounts();
                            //}
                        }
                        break;
                    case 2:
                        // do nothing
                        // complete click
                        // handled in finish event
                        break;
                    default:
                        break;
                }
            }
            else if (data.direction == "previous") {
                switch (data.step) {
                    case 1:
                        // not possible
                        break;
                    case 2:
                        this.updateActionButtons();
                        break;
                    default:
                        break;
                }
            }
        });
        $('#uploadResumesWizard').on('finished.fu.wizard', (evt, data) => {
            if (this.jobContextExistsFlag) {
                if (this.candidatesToAssociateList.length != 0) {
                    this.associateCandidates(() => {
                        if (this.completeCallback) {
                            this.completeCallback();
                        }
                    });
                }
                else {
                    if (this.completeCallback) {
                        this.completeCallback();
                    }
                }
            }
            else {
                if (this.completeCallback) {
                    this.completeCallback();
                }
            }
        });
        return uploadResumesWizard;
    }
    _runScoringForResumes() {
        let jobId = null;
        if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
            jobId = this.jobId;
        }
        this.resumeService.runResumesForScoring(this.uploadResumesResponse, jobId, (data) => {
            angular.forEach(data, (val, key) => {
                if (_.isNull(val.firstName)) {
                    val.firstName = "-";
                }
                if (_.isNull(val.lastName)) {
                    val.lastName = "-";
                }
                if (_.isNull(val.email)) {
                    val.email = "-";
                }
                if (_.isNull(val.phone)) {
                    val.phone = "-";
                }
                val.name = val.firstName + ' ' + val.lastName;
                if (val.mobilePhoneCountryCodePresent) {
                    let phoneNumberObject = libphonenumber.parse(val.phone.toString());
                    if (phoneNumberObject.phone !== undefined) {
                        val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                    }
                }
                // floor the match score to the lower integer value.
                val.score = Math.floor(parseFloat(val.score));
                val.selectedFlag = false;
                if (val.score >= val.jobThresholdScore) {
                    val.intelligenceScorePassFlag = true;
                }
                this.candidatesList.push(val);
            });
            this.scoringCandidatesFlag = false;
            this.resumeScoringDoneFlag = true;
            // enable previous and next (complete) button after processing
            this.disableNextButtonFlag = false;
            this.disablePreviousButtonFlag = false;
            //if(!this.jobContextExistsFlag){
            if (this.candidateProcessedCallback) {
                this.candidateProcessedCallback();
            }
            this._getCandidateCounts();
            //}
        }, (error) => {
            // do nothing
        });
    }
    runResumeScoringForAssociate(contactDetails, type) {
        let isUpdate = false;
        if (contactDetails) {
            isUpdate = (type && type === 'save') ? true : false;
            this.uploadResumesResponse.candidateContactDetail = contactDetails;
        }
        this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
        this.utilityService.showLoadingModal('Saving...');
        this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, (data) => {
            this.utilityService.hideLoadingModal();
            if (!this.isSingleCandidateUpload) {
                this.candidateDetailsToUpdate = data;
                if (!isUpdate) {
                    this.additionalMatchRuleVerifiedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerified;
                    this.additionalMatchRuleVerificationPassedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed;
                }
                let fetchNewCandidateDetails = {
                    firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].newValue,
                    lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].newValue,
                    email: this.candidateDetailsToUpdate.candidateConflictDetails[2].newValue,
                    phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].newValue
                };
                this.fetchOldCandidateDetails = {
                    firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].oldValue,
                    lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].oldValue,
                    email: this.candidateDetailsToUpdate.candidateConflictDetails[2].oldValue,
                    phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].oldValue
                };
                if (this.candidateDetailsToUpdate.candidateUpdated) {
                    if (!isUpdate) {
                        this.isDirectCandidateUpdate = true;
                    }
                    this.scoringCandidatesFlag = false;
                    this.resumeScoringDoneFlag = true;
                    this.disableNextButtonFlag = false;
                    this.disablePreviousButtonFlag = false;
                    this.candidatesList.push(fetchNewCandidateDetails);
                }
                else if (this.candidateDetailsToUpdate.candidateConflicts) {
                    this.isDirectCandidateUpdate = false;
                    this.showCandidateUpdateFailureMessage = true;
                    this.scoringCandidatesFlag = false;
                    this.resumeScoringDoneFlag = true;
                    this.disableNextButtonFlag = false;
                    this.disablePreviousButtonFlag = false;
                    if (isUpdate) {
                        this.candidateDetailsToUpdate.additionalMatchRuleVerified = this.additionalMatchRuleVerifiedCopy;
                        this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed = this.additionalMatchRuleVerificationPassedCopy;
                    }
                }
                else {
                    this.isDirectCandidateUpdate = false;
                    this._showConflictsModal(this.candidateDetailsToUpdate);
                }
                if (this.candidateProcessedCallback) {
                    this.candidateProcessedCallback();
                }
            }
            else {
                if (type && type === 'save') {
                    this.alertsAndNotificationsService.showAlertWithCallBack('Success', 'Candidate details updated successfully.', 'success', () => {
                        // Do Nothing
                    });
                }
                else if (type && type === 'cancel') {
                    this.alertsAndNotificationsService.showAlertWithCallBack('Update Cancelled', 'Candidate update cancelled. No changes were made to the candidate details.', 'info', () => {
                        // Do Nothing
                    });
                }
                if (this.completeCallback) {
                    this.completeCallback();
                }
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (this.completeCallback) {
                this.completeCallback();
            }
            this.utilityService.hideLoadingModal();
        });
    }
    _showConflictsModal(candidateConflictDetails) {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(() => {
            let conflictModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                component: 'compareAndUpdateCandidateDetailsModal',
                resolve: {
                    candidateConflictDetails: () => {
                        return candidateConflictDetails;
                    }
                }
            });
            conflictModal.result.then(callbackObject => {
                if (callbackObject.callbackType == 'save') {
                    this.runResumeScoringForAssociate(callbackObject.entity, 'save');
                }
                else if (callbackObject.callbackType == 'cancel') {
                    if (this.isSingleCandidateUpload) {
                        this.runResumeScoringForAssociate(callbackObject.entity, 'cancel');
                    }
                    else {
                        this.scoringCandidatesFlag = false;
                        this.resumeScoringDoneFlag = true;
                        this.disableNextButtonFlag = false;
                        this.disablePreviousButtonFlag = false;
                        this.candidatesList = [];
                        this.candidatesList.push(this.fetchOldCandidateDetails);
                    }
                }
                else {
                    this.scoringCandidatesFlag = false;
                    this.resumeScoringDoneFlag = true;
                    this.disableNextButtonFlag = false;
                    this.disablePreviousButtonFlag = false;
                    this.candidatesList = [];
                    this.candidatesList.push(this.fetchOldCandidateDetails);
                }
            }, dismiss => {
                //do nothing
            });
        }, 300);
    }
    cancelUploadResumes() {
        let message = "Are you sure you want to cancel ?";
        let showPopUp = true;
        let createCandidatesFlag = false;
        if (this.resumeScoringDoneFlag) {
            // do nothing.
        }
        else {
            // scoring was not done
            if (this.resumeList.length) {
                // resumes were uploaded
                message = "No job matches will be created for the uploaded candidate(s).<br>Do you still want to continue?";
                createCandidatesFlag = true;
            }
            else if (this.resumeUploadDropzone.files.length > 0) {
                // resumes not uploaded, exist in the dropzone
                message = "Are you sure you want to cancel ?<br>Un-uploaded files exist in the upload area.";
            }
            else {
                // no uploaded resumes exist. no need to show confirmation popup.
                showPopUp = false;
            }
        }
        if (showPopUp) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    let message = "<p class='text-center'>Creating candidate(s) for uploaded resume(s) <i class='fa fa-spinner fa-spin'></i><br>Please go to Candidates screen to view the candidate(s).</p>";
                    if (result) {
                        if (createCandidatesFlag) {
                            let createUploadedCandidatesDialog = bootbox.dialog({
                                message: message,
                                closeButton: false
                            });
                            // scoring was not done and but resumes were uploaded.
                            // make service call to create candidates
                            this.resumeService.runResumesWithoutScoring(this.uploadResumesResponse, this.jobId, (data) => {
                                createUploadedCandidatesDialog.modal('hide');
                                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                // candidates added successfully without creating job matches
                                if (this.cancelCallback) {
                                    this.cancelCallback();
                                }
                            }, (error) => {
                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            });
                        }
                        else {
                            if (this.cancelCallback) {
                                this.cancelCallback();
                            }
                        }
                    }
                    else {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            if (this.cancelCallback) {
                this.cancelCallback();
            }
        }
    }
    /**
     * update the action buttons
     */
    updateActionButtons() {
        // if resumes exist and scoring is completed, then the functions on this tab are disabled.
        if (this.resumeList.length > 0) {
            this.disableSourceTypesFlag = true;
            this.resumeUploadDropzone.clickable = false;
            this.disableUploadButtonFlag = true;
            this.disableNextButtonFlag = false;
        }
        else {
            // in else because no resumes have been uploaded yet
            if (this.fileExistsFlag) {
                // if files exist in drop zone
                if (!_.isNull(this.sourceTypeId)) {
                    // and source type is chosen
                    this.disableUploadButtonFlag = false;
                    // this.disableSourceTypesFlag = true;
                }
                else {
                    // and source type is not chosen
                    this.disableUploadButtonFlag = true;
                    // this.disableSourceTypesFlag = false;
                }
            }
            else {
                // files do not exist in drop zone
                this.disableUploadButtonFlag = true;
                this.disableSourceTypesFlag = false;
            }
            // disable the next button
            this.disableNextButtonFlag = true;
        }
        this.$timeout(() => {
            this.$scope.$apply();
        }, 200);
    }
    candidateToAssociateToggle(candidate) {
        // if it is selected, add to associate list
        if (candidate.selectedFlag) {
            this.candidatesToAssociateList.push(candidate);
        }
        else {
            // if selected is removed, remove from candidates to associate list
            _.remove(this.candidatesToAssociateList, {
                candidateId: candidate.candidateId
            });
            _.remove(this.createJobMatchesObject.overrideNoteDetails, {
                candidateId: candidate.candidateId
            });
        }
    }
    associateCandidates(successCallback) {
        angular.forEach(this.candidatesToAssociateList, (val, key) => {
            this.createJobMatchesObject.candidateIds.push(val.candidateId);
        });
        this.associatingCandidatesFlag = true;
        let associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this.createJobMatchesObject.isAddCandidate = true;
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, (data) => {
            this.associatingCandidatesFlag = false;
            associatingDialog.modal('hide');
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(this.candidatesToAssociateList, (val, key) => {
                // find each associated candidate in the original candidates list
                let index = _.findIndex(this.candidatesList, {
                    candidateId: val.candidateId
                });
                // for each candidate, set the added successfully flag to true and selected flag to false
                this.candidatesList[index].candidateMatchedToJob = true;
                this.candidatesList[index].statusOfJobMatch = 'Candidate Added.';
                this.candidatesList[index].selectedFlag = false;
            });
            // make the candidates to associate list as empty.
            this.candidatesToAssociateList = [];
            // get the candidate counts again as manually matched counts might have changed.
            this._getCandidateCounts();
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.associatingCandidatesFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getCandidateCounts() {
        // get counts of candidates that matched jobs.
        // call the get counts API
        this.gettingCountsFlag = true;
        this.resumeService.getCandidateCount(this.uploadResumesResponse.transactionID, (data) => {
            this.candidateCount = angular.merge(new CandidateCount(), data);
            if (this.candidateCount.unMatchedCandidateCount == 0) {
                this.displaySelectDeselectButtonFlag = false;
            }
            this.updateActionButtons();
            this.gettingCountsFlag = false;
        }, (error) => {
            this.gettingCountsFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    displayCandidates(countType) {
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(() => {
            this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                component: 'uploadResumesTransactionCandidatesModal',
                windowTopClass: 'upload-resumes-candidates-modal-large',
                resolve: {
                    countsObject: () => {
                        return this.candidateCount;
                    },
                    countType: () => {
                        return countType;
                    },
                    activityMap: () => {
                        return this.activityMap;
                    }
                }
            });
        }, 300);
    }
    showOverrideCandidateSuspensionModal(candidate) {
        let candidateId = candidate.candidateId;
        let candidateName = candidate.name;
        let suspendedMonths = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
        let releaseDate = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
        let allowOverride = candidate.allowOverride;
        let releasedJobDetails = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
        let type = candidate.overrideFor === "RELEASE" ? "release" : "jobLeft";
        if (allowOverride) {
            $(".modal").addClass("upload-resumes-modal-medium");
            this.$timeout(() => {
                let warningModal = this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowClass: 'four-dot-five-modal-medium',
                    component: 'uploadResumesActionsModal',
                    resolve: {
                        candidateId: () => {
                            return candidateId;
                        },
                        candidateName: () => {
                            return candidateName;
                        },
                        suspendedMonths: () => {
                            return suspendedMonths;
                        },
                        releaseDate: () => {
                            return releaseDate;
                        },
                        allowOverride: () => {
                            return allowOverride;
                        },
                        releasedJobDetails: () => {
                            return releasedJobDetails;
                        },
                        type: () => {
                            return type;
                        }
                    }
                });
                warningModal.result.then((callbackObject) => {
                    if (callbackObject.callbackType == 'save') {
                        let index = _.findIndex(this.candidatesList, {
                            candidateId: candidate.candidateId
                        });
                        this.createJobMatchesObject.overrideNoteDetails.push(callbackObject.entity);
                        this.candidatesList[index].allowManualMatch = true;
                        this.candidatesList[index].showOverride = false;
                        this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                        this.candidatesList[index].selectedFlag = true;
                        this.candidateToAssociateToggle(this.candidatesList[index]);
                    }
                }, dismiss => {
                    //do nothing
                });
            }, 300);
        }
        else {
            let displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    }
    getAllSourceTypes(successCallback) {
        this.resumeService.getAllSourceTypes((data) => {
            this.sourceTypeList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setDefaultSourceType() {
        if (this.defaultJobSourceTypeId !== undefined && this.defaultJobSourceTypeId !== "" && !_.isNull(this.defaultJobSourceTypeId)) {
            let index = this.sourceTypeList.findIndex((sourceType) => {
                return sourceType.id == this.defaultJobSourceTypeId;
            });
            if (index !== -1) {
                this.sourceType = this.sourceTypeList[index];
                this.sourceTypeId = this.sourceType.id;
            }
        }
    }
    sourceTypeChanged() {
        if (angular.isDefined(this.sourceType) && angular.isDefined(this.sourceType.id)) {
            this.sourceTypeId = this.sourceType.id;
            this.updateActionButtons();
        }
        else {
            this.sourceTypeId = null;
        }
    }
    uploadResumes() {
        this.uploadResumesForm.$submitted = true;
        if (!this.uploadResumesForm.$invalid) {
            this.resumeUploadDropzone.processQueue();
        }
    }
    toggleSelectAllCandidates() {
        if (this.selectedAllCandidatesFlag) {
            // if selectAllCandidates was already selected, remove all selections
            angular.forEach(this.candidatesList, (val, key) => {
                // if candidate was not already added successfully and was selected, de select it and remove it from associate list
                if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = false;
                    // if selected is removed, remove from candidates to associate list
                    _.remove(this.candidatesToAssociateList, {
                        candidateId: val.candidateId
                    });
                }
            });
            this.selectedAllCandidatesFlag = false;
        }
        else {
            // if selectAllCandidates was not already selected
            angular.forEach(this.candidatesList, (val, key) => {
                // if candidate was not already added successfully and also not already selected, select it and add to associate list
                if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = true;
                    this.candidatesToAssociateList.push(val);
                }
            });
            this.selectedAllCandidatesFlag = true;
        }
    }
    jobCompare(candidate) {
        let actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.id = candidate.candidateId;
        candidate.jobMatchJobId = this.jobId;
        this.jobMatchActionsService.performAction('uploadResumes', actionObject, candidate, () => {
        }, () => {
        });
    }
    receiveFormalizedComment(event) {
        this.otherSourceTypeNotes = event;
    }
    onVoiceTranscript(transcript) {
        if (this.otherSourceTypeNotes) {
            this.otherSourceTypeNotes += ' ' + transcript;
        }
        else {
            this.otherSourceTypeNotes = transcript;
        }
    }
}
UploadSingleResumeController.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'jobMatchActionsService', 'alertsAndNotificationsService', 'resumeService', 'jobMatchService', 'candidateService', 'jobService', 'MESSAGECONSTANTS', 'utilityService'];
import * as TEMPLATE from 'raw-loader!./upload-single-resume.html';
export const UploadSingleResumeComponent = {
    selector: 'uploadSingleResume',
    component: {
        bindings: {
            jobId: '@',
            candidateId: '@',
            cancelCallback: '&',
            candidateProcessedCallback: '&',
            completeCallback: '&',
            controlObject: '=',
            context: '@',
            formalizeActivityPayload: '<',
            sourceScreen: '@'
        },
        controller: UploadSingleResumeController,
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=upload-single-resume.component.js.map